import axios from "axios";
import Config from "../../config/index";
import {
  CREATE_TRANSFER_ORDER_FAILURE,
  CREATE_TRANSFER_ORDER_FOR_QTY_FAILURE,
  CREATE_TRANSFER_ORDER_FOR_QTY_REQUEST,
  CREATE_TRANSFER_ORDER_FOR_QTY_SUCCESS,
  CREATE_TRANSFER_ORDER_REQUEST,
  CREATE_TRANSFER_ORDER_SUCCESS,
  DOWNLOAD_TRANSFER_ORDER_FAILURE,
  DOWNLOAD_TRANSFER_ORDER_REQUEST,
  DOWNLOAD_TRANSFER_ORDER_SUCCESS,
  GET_AVAILABLEQTYFORTO_FAILURE,
  GET_AVAILABLEQTYFORTO_REQUEST,
  GET_AVAILABLEQTYFORTO_SUCCESS,
  GET_LEVEL1_BY_LEVEL_UPDATED_FAILURE,
  GET_LEVEL1_BY_LEVEL_UPDATED_REQUEST,
  GET_LEVEL1_BY_LEVEL_UPDATED_SUCCESS,
  GET_LEVEL2_BY_LEVEL_UPDATED_FAILURE,
  GET_LEVEL2_BY_LEVEL_UPDATED_REQUEST,
  GET_LEVEL2_BY_LEVEL_UPDATED_SUCCESS,
  GET_LEVEL3_BY_LEVEL_UPDATED_FAILURE,
  GET_LEVEL3_BY_LEVEL_UPDATED_REQUEST,
  GET_LEVEL3_BY_LEVEL_UPDATED_SUCCESS,
  GET_LEVEL4_BY_LEVEL_UPDATED_FAILURE,
  GET_LEVEL4_BY_LEVEL_UPDATED_REQUEST,
  GET_LEVEL4_BY_LEVEL_UPDATED_SUCCESS,
  GET_SUIDS_FAILURE,
  GET_SUIDS_REQUEST,
  GET_SUIDS_SUCCESS,
  GET_TRANSFERORDERS_FAILURE,
  GET_TRANSFERORDERS_REQUEST,
  GET_TRANSFERORDERS_SUCCESS,
  GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_FAILURE,
  GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_REQUEST,
  GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_SUCCESS,
  SPLIT_QTY_FAILURE,
  SPLIT_QTY_REQUEST,
  SPLIT_QTY_SUCCESS,
} from "./transferOrderTypes";
let baseUrl = Config.baseUrl;

const getTransferOrdersRequest = () => {
  return {
    type: GET_TRANSFERORDERS_REQUEST,
  };
};

const getTransferOrdersSuccess = (payload) => {
  return {
    type: GET_TRANSFERORDERS_SUCCESS,
    payload: payload,
  };
};

const getTransferOrdersFailure = (error) => {
  return {
    type: GET_TRANSFERORDERS_FAILURE,
    payload: error,
  };
};

const getAllTransferOrders = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getTransferOrdersRequest());
    let url = `${baseUrl}/transfer_order/common/get_transfer_order?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getTransferOrdersSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getTransferOrdersFailure(err.message));
      });
  };
};

const getTransferOrderDownloadsRequest = () => {
  return {
    type: DOWNLOAD_TRANSFER_ORDER_REQUEST,
  };
};

const getTransferOrderDownloadsSuccess = (payload) => {
  return {
    type: DOWNLOAD_TRANSFER_ORDER_SUCCESS,
    payload: payload,
  };
};

const getTransferOrderDownloadsFailure = (error) => {
  return {
    type: DOWNLOAD_TRANSFER_ORDER_FAILURE,
    payload: error,
  };
};

const getTransferOrderDownloads = (searchObject, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getTransferOrderDownloadsRequest());
    let url = `${baseUrl}/transfer_order/common/download_transfer_order?search=${searchObject}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getTransferOrderDownloadsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getTransferOrderDownloadsFailure(err.message));
      });
  };
};

const createTransferOrderRequest = () => {
  return {
    type: CREATE_TRANSFER_ORDER_REQUEST,
  };
};

const createTransferOrderSuccess = (payload) => {
  return {
    type: CREATE_TRANSFER_ORDER_SUCCESS,
    payload: payload,
  };
};

const createTransferOrderFailure = (error) => {
  return {
    type: CREATE_TRANSFER_ORDER_FAILURE,
    payload: error,
  };
};

const createTransferOrder = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createTransferOrderRequest());
    let url = `${baseUrl}/transfer_order/common/create_with_suids`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createTransferOrderSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createTransferOrderFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createTransferOrderW2Request = () => {
  return {
    type: CREATE_TRANSFER_ORDER_REQUEST,
  };
};

const createTransferOrderW2Success = (payload) => {
  return {
    type: CREATE_TRANSFER_ORDER_SUCCESS,
    payload: payload,
  };
};

const createTransferOrderW2Failure = (error) => {
  return {
    type: CREATE_TRANSFER_ORDER_FAILURE,
    payload: error,
  };
};

const createTransferOrderW2 = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createTransferOrderW2Request());
    let url = `${baseUrl}/transfer_order/w2/create_with_suids`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createTransferOrderW2Success(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createTransferOrderW2Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createTransferOrderForQtyRequest = () => {
  return {
    type: CREATE_TRANSFER_ORDER_FOR_QTY_REQUEST,
  };
};

const createTransferOrderForQtySuccess = (payload) => {
  return {
    type: CREATE_TRANSFER_ORDER_FOR_QTY_SUCCESS,
    payload: payload,
  };
};

const createTransferOrderForQtyFailure = (error) => {
  return {
    type: CREATE_TRANSFER_ORDER_FOR_QTY_FAILURE,
    payload: error,
  };
};

const createTransferOrderForQty = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createTransferOrderForQtyRequest());
    let url = `${baseUrl}/transfer_order/common/create_with_qty`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createTransferOrderForQtySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createTransferOrderForQtyFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createTransferOrderForQtyW2Request = () => {
  return {
    type: CREATE_TRANSFER_ORDER_FOR_QTY_REQUEST,
  };
};

const createTransferOrderForQtyW2Success = (payload) => {
  return {
    type: CREATE_TRANSFER_ORDER_FOR_QTY_SUCCESS,
    payload: payload,
  };
};

const createTransferOrderForQtyW2Failure = (error) => {
  return {
    type: CREATE_TRANSFER_ORDER_FOR_QTY_FAILURE,
    payload: error,
  };
};

const createTransferOrderForQtyW2 = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createTransferOrderForQtyW2Request());
    let url = `${baseUrl}/transfer_order/w2/create_with_qty`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createTransferOrderForQtyW2Success(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createTransferOrderForQtyW2Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getSuidsRequest = () => {
  return {
    type: GET_SUIDS_REQUEST,
  };
};

const getSuidsSuccess = (payload) => {
  return {
    type: GET_SUIDS_SUCCESS,
    payload: payload,
  };
};

const getSuidsFailure = (error) => {
  return {
    type: GET_SUIDS_FAILURE,
    payload: error,
  };
};

const getSuids = (itemId, activityIdSelected, searchTerm, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSuidsRequest());
    let url = `${baseUrl}/transfer_order/common/get_suids?itemId=${itemId}&mvtId=${activityIdSelected}&search=${searchTerm}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSuidsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSuidsFailure(err.message));
      });
  };
};

const getAvailableQtyForToRequest = () => {
  return {
    type: GET_AVAILABLEQTYFORTO_REQUEST,
  };
};

const getAvailableQtyForToSuccess = (payload) => {
  return {
    type: GET_AVAILABLEQTYFORTO_SUCCESS,
    payload: payload,
  };
};

const getAvailableQtyForToFailure = (error) => {
  return {
    type: GET_AVAILABLEQTYFORTO_FAILURE,
    payload: error,
  };
};

const getAvailableQtyForTo = (itemId, location, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAvailableQtyForToRequest());
    let url = `${baseUrl}/picklist/available_qty_for_location?item_id=${itemId}&location_code=${location}`;
    return axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAvailableQtyForToSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getAvailableQtyForToFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getWarehousesByItemCodeAndMovementRequest = () => {
  return {
    type: GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_REQUEST,
  };
};

const getWarehousesByItemCodeAndMovementSuccess = (payload) => {
  return {
    type: GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_SUCCESS,
    payload: payload,
  };
};

const getWarehousesByItemCodeAndMovementFailure = (error) => {
  return {
    type: GET_WAREHOUSES_BY_ITEM_ID_MOVEMENT_FAILURE,
    payload: error,
  };
};

const getWarehousesByItemCodeAndMovement = (
  activityIdSelected,
  itemId,
  jwtToken,
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWarehousesByItemCodeAndMovementRequest());
    // let url = `${baseUrl}/reports/warehouse_occupancy?locationCode=${locationCode}`;
    // let url = `${baseUrl}/warehouse_by_acnId=${activityIdSelected}&itemId=${itemId}`;
    let url = `${baseUrl}/warehouse_by_acn_itemId?acnId=${activityIdSelected}&itemId=${itemId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getWarehousesByItemCodeAndMovementSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWarehousesByItemCodeAndMovementFailure(err.message));
      });
  };
};

const getLevel1ByLevelForTransferOrderRequest = () => {
  return {
    type: GET_LEVEL1_BY_LEVEL_UPDATED_REQUEST,
  };
};

const getLevel1ByLevelForTransferOrderSuccess = (payload) => {
  return {
    type: GET_LEVEL1_BY_LEVEL_UPDATED_SUCCESS,
    payload: payload,
  };
};

const getLevel1ByLevelForTransferOrderFailure = (error) => {
  return {
    type: GET_LEVEL1_BY_LEVEL_UPDATED_FAILURE,
    payload: error,
  };
};

const getLevel1ByLevelForTransferOrder = (
  warehouseId,
  parentId,
  itemId,
  acnId,
  jwtToken,
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getLevel1ByLevelForTransferOrderRequest());
    // let url = `${baseUrl}/location/level?level=1&warehouse_id=${warehouseId}&parent_id=0`;
    let url = `${baseUrl}/location/level_by_item_and_mvt?warehouse_Id=${warehouseId}&parent_id=0&item_id=${itemId}&acn_id=${acnId}&level=1`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLevel1ByLevelForTransferOrderSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getLevel1ByLevelForTransferOrderFailure(err.message));
      });
  };
};

const getLevel2ByLevelForTransferOrderRequest = () => {
  return {
    type: GET_LEVEL2_BY_LEVEL_UPDATED_REQUEST,
  };
};

const getLevel2ByLevelForTransferOrderSuccess = (payload) => {
  return {
    type: GET_LEVEL2_BY_LEVEL_UPDATED_SUCCESS,
    payload: payload,
  };
};

const getLevel2ByLevelForTransferOrderFailure = (error) => {
  return {
    type: GET_LEVEL2_BY_LEVEL_UPDATED_FAILURE,
    payload: error,
  };
};

const getLevel2ByLevelForTransferOrder = (
  warehouseId,
  parentId,
  itemId,
  acnId,
  jwtToken,
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getLevel2ByLevelForTransferOrderRequest());
    // let url = `${baseUrl}/location/level?level=2&warehouse_id=${warehouseId}&parent_id=${parentId}`;
    let url = `${baseUrl}/location/level_by_item_and_mvt?warehouse_Id=${warehouseId}&parent_id=${parentId}&item_id=${itemId}&acn_id=${acnId}&level=2`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLevel2ByLevelForTransferOrderSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getLevel2ByLevelForTransferOrderFailure(err.message));
      });
  };
};

const getLevel3ByLevelForTransferOrderRequest = () => {
  return {
    type: GET_LEVEL3_BY_LEVEL_UPDATED_REQUEST,
  };
};

const getLevel3ByLevelForTransferOrderSuccess = (payload) => {
  return {
    type: GET_LEVEL3_BY_LEVEL_UPDATED_SUCCESS,
    payload: payload,
  };
};

const getLevel3ByLevelForTransferOrderFailure = (error) => {
  return {
    type: GET_LEVEL3_BY_LEVEL_UPDATED_FAILURE,
    payload: error,
  };
};

const getLevel3ByLevelForTransferOrder = (
  warehouseId,
  parentId,
  itemId,
  acnId,
  jwtToken,
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getLevel3ByLevelForTransferOrderRequest());
    // let url = `${baseUrl}/location/level?level=3&warehouse_id=${warehouseId}&parent_id=${parentId}`;
    let url = `${baseUrl}/location/level_by_item_and_mvt?warehouse_Id=${warehouseId}&parent_id=${parentId}&item_id=${itemId}&acn_id=${acnId}&level=3`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLevel3ByLevelForTransferOrderSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getLevel3ByLevelForTransferOrderFailure(err.message));
      });
  };
};

const getLevel4ByLevelForTransferOrderRequest = () => {
  return {
    type: GET_LEVEL4_BY_LEVEL_UPDATED_REQUEST,
  };
};

const getLevel4ByLevelForTransferOrderSuccess = (payload) => {
  return {
    type: GET_LEVEL4_BY_LEVEL_UPDATED_SUCCESS,
    payload: payload,
  };
};

const getLevel4ByLevelForTransferOrderFailure = (error) => {
  return {
    type: GET_LEVEL4_BY_LEVEL_UPDATED_FAILURE,
    payload: error,
  };
};

const getLevel4ByLevelForTransferOrder = (
  warehouseId,
  parentId,
  itemId,
  acnId,
  jwtToken,
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getLevel4ByLevelForTransferOrderRequest());
    // let url = `${baseUrl}/location/level?level=4&warehouse_id=${warehouseId}&parent_id=${parentId}`;
    let url = `${baseUrl}/location/level_by_item_and_mvt?warehouse_Id=${warehouseId}&parent_id=${parentId}&item_id=${itemId}&acn_id=${acnId}&level=4`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLevel4ByLevelForTransferOrderSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getLevel4ByLevelForTransferOrderFailure(err.message));
      });
  };
};

const splitQtyRequest = () => {
  return {
    type: SPLIT_QTY_REQUEST,
  };
};

const splitQtySuccess = (payload) => {
  return {
    type: SPLIT_QTY_SUCCESS,
    payload: payload,
  };
};

const splitQtyFailure = (error) => {
  return {
    type: SPLIT_QTY_FAILURE,
    payload: error,
  };
};

const splitQty = (suid, splitQty, printerId, jwtToken) => {
  let payload = {
    suid: suid,
    splittingQty: splitQty,
    printerId: printerId,
  };
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(splitQtyRequest());
    let url = `${baseUrl}/kitting/split_suid_dashboard`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(splitQtySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(splitQtyFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  createTransferOrder,
  createTransferOrderForQty,
  createTransferOrderForQtyW2,
  createTransferOrderW2,
  getAllTransferOrders,
  getAvailableQtyForTo,
  getLevel1ByLevelForTransferOrder,
  getLevel2ByLevelForTransferOrder,
  getLevel3ByLevelForTransferOrder,
  getLevel4ByLevelForTransferOrder,
  getSuids,
  getTransferOrderDownloads,
  getWarehousesByItemCodeAndMovement,
  splitQty,
};
